import policiesReducer, { defaultState } from "./policiesReducer";
import type { ArchivedRecommendation, Holdings, NjordPolicy, PoliciesState, Policy, PolicyDetails, PolicyView, SavingsPercentage } from "./types";

export { type ArchivedRecommendation, defaultState, type Holdings, type NjordPolicy, type PoliciesState, type Policy, type PolicyDetails, type PolicyView, type SavingsPercentage };
export default policiesReducer;
